﻿import $ from "jquery";
import tinymce from 'tinymce';
import "datatables.net";
import "datatables.net-rowreorder-dt";
import 'bootstrap-icons/font/bootstrap-icons.css';
import bootbox from 'bootbox';
import { showMessage, initTinymce } from "./main";
import { chunkUploadAndFillForDownloadFields } from "./upload";

let dataTable: any;

$(() => {
    var currentPage = $("#currentPage").val();
    if (currentPage != "materialDetail") return;

    init();
});

function init() {
    initTinymce('Description', 300);
    initTinymce('Definition', 600);
    initTinymce('DefinitionLastPart', 600);

    initForDownloadDataTable();
    initShowImageSelectModal();
    initUploadFile();

    initForDownloadSaveOrder();
    initForDownloadEdit();
    initForDownloadDelete();
    initForDownloadSave();
}

function initForDownloadDataTable() {
    dataTable = $('#tableForDownload').DataTable({
        rowReorder: {
            enable: true,
            selector: 'td:first-child'
        },
        ordering: true,
        columnDefs: [
            {
                target: 0,
                visible: false,
                searchable: false
            },
            {
                target: 1,
                visible: false
            },
            { 'orderable': false, 'targets': [1, 2, 3] }
        ],
        language: {
            info: 'Strana _PAGE_ z _PAGES_',
            infoEmpty: 'Žiadne údaje',
            infoFiltered: '(filtrované z _MAX_ celkových záznamov)',
            lengthMenu: 'Zobraziť _MENU_ záznamov na stránku',
            zeroRecords: 'Nič sa nenašlo',
            search: 'Hľadať:'
        }
    });
}

function initShowImageSelectModal() {
    $("#selectImage").off('click');

    $('#selectImage').on('click', function () {
        $('#uploadFileModal').modal('show');
    });
}

function initShowFileSelectModal() {
    $("#selectFile").off('click');
    $('#selectFile').on('click', function () {

        let fileInfo = $('#FileInfo')[0] as HTMLInputElement;
        let fileInput = document.getElementById("FileInput");

        // Skryť informáciu o uloženom súbore
        if (fileInfo) {
            fileInfo.style.display = "none";
        }
        // Zobraziť vstup pre nahranie nového súboru
        if (fileInput) {
            fileInput.style.display = "block";
        }

    });
}
function initUploadFile() {
    $('#uploadFile').on('click', function () {

        let fileInput = $('#imageForDownload')[0] as HTMLInputElement;
        let file = fileInput.files[0];

        let id = $('#Id').val();
        let languageCode = $('#LanguageCode').val();

        if (file) {
            let formData = new FormData();
            formData.append("image", file);
            formData.append("id", id.toString());
            formData.append("languageCode", languageCode.toString());

            $.ajax({
                url: '/Material/UploadImage',
                type: 'POST',
                //data: JSON.stringify(formData), 
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    $('#uploadFileModal').modal('hide');
                    $('#ImageFileName').val(response.fileName);
                    $('#OriginalImageFileName').val(response.originalImageFileName);
                    $('#ImageUrl').val(response.imageUrl);
                    $('#imgImageUrl').attr('src', response.imageUrl);
                },
                error: function (xhr) {
                    let msg = xhr?.responseJSON?.message || "Chyba pri nahrávaní súboru.";
                    showMessage(msg, "Chyba!");  
                }
            });
        } else {
            showMessage("Prosím, vyberte súbor.", "Chyba!");   
        }
    });
}

function initForDownloadSaveOrder() {
    $("#btnSaveOrderMaterialDownload").on('click', function () {

        var data = dataTable.rows({ order: 'applied' }).data();
        var ids = [];

        let id = $('#Id').val();

        data.each(function (value, index) {
            ids.push(value[1]);
        });

        var formData = {
            ids: ids,
            masterId: id,
        };

        let request = $.ajax({
            type: 'Post',
            url: '/ForDownload/SaveMaterialOrder/',
            data: JSON.stringify(formData),
            contentType: 'application/json',
            beforeSend: function () {
                $('#spinnerContainer').removeClass('d-none');
            },
            complete: function () {
                $('#spinnerContainer').addClass('d-none');
            }
        });

        request.done(function (res) {
            if (res.error == true) {
                showMessage(res.message, "Chyba!");
            }
            else {
                $("#forDownloadList").html(res.html);
                initForDownloadDataTable();
                initForDownloadEdit();
                initForDownloadDelete();
                showMessage(res.message);
            }
        });
        request.fail(function (jqXHR) {
            console.error(jqXHR)
        });
    });
}

function initForDownloadEdit() {

    $("#tableForDownload tbody").off('click', '.edit');
    $('#tableForDownload tbody').on('click', '.edit', function () {
        let id = $(this).data("id");
        editForDownload(id);
    });

    $("#editForDownloadModal").on('hidden.bs.modal', () => {
        const editor = tinymce.get('ForDownloads_ForDownloadDescription');
        if (editor) {
            editor.remove(); // Zničí TinyMCE editor            
        }
    });

    $("#btnNewForDownload").on('click', function () {
        editForDownload(0);
    });

}

function initForDownloadDelete() {

    $("#tableForDownload tbody").off('click', '.delete');
    $('#tableForDownload tbody').on('click', '.delete', function () {

        let id = $(this).data("id");

        bootbox.confirm('Naozaj chcete zmazať položku?',
            function (result) {
                if (result == true) {
                    deleteForDownload(id);
                }
            });
    });
}

function deleteForDownload(id: number) {

    let request = $.ajax({
        type: 'Post',
        url: '/ForDownload/Delete/' + id,
        contentType: 'application/json',
        beforeSend: function () {
            $('#spinnerContainer').removeClass('d-none');
        },
        complete: function () {
            $('#spinnerContainer').addClass('d-none');
        }
    });

    request.done(function (res) {
        if (res.error == true) {
            showMessage(res.message);
        }
        else {

            var row = dataTable.row('#tr_' + id);
            row.remove().draw();
        }

    });
    request.fail(function (jqXHR) {
        console.error(jqXHR)
    });
}

function editForDownload(id: number) {

    let url = '/ForDownload/EditModal/' + id;
    if (id == 0) {
        let materialId = $('#Id').val();
        url = '/ForDownload/NewModal?materialId=' + materialId;
    }

    let request = $.ajax({
        type: 'GET',
        url: url,
        contentType: 'application/json',
        beforeSend: function () {
            $('#spinnerContainer').removeClass('d-none');
        },
        complete: function () {
            $('#spinnerContainer').addClass('d-none');
        }
    });

    request.done(function (res) {
        $("#forDownloadDetailBody").html(res.html);

        initTinymce('ForDownloads_ForDownloadDescription', 300);
        $("#editForDownloadModal").modal("toggle");

        initShowFileSelectModal();

        const editor = tinymce.EditorManager.get('ForDownloads_ForDownloadDescription');
    });
    request.fail(function (jqXHR) {
        console.error(jqXHR)
    });
}


function initForDownloadSave() {

    function postModalForm(url: string, form: HTMLFormElement) {
        tinymce.triggerSave();

        const formData = new FormData(form);

        // !!! už NIKDY nepridávaj file do formData pri veľkých upload-och
        // let fileInput = $('#fileForDownload')[0] as HTMLInputElement;
        // if (fileInput.files && fileInput.files.length > 0) {
        //     formData.append("file", fileInput.files[0]);
        // }

        return $.ajax({
            type: 'POST',
            url: url,
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: function () {
                $('#spinnerContainer').removeClass('d-none');
            },
            complete: function () {
                $('#spinnerContainer').addClass('d-none');
            }
        });
    }

    $("#btnSaveForDownload").on('click', function () {

        var url = '/ForDownload/EditModal';
        var id = $("#ForDownloads_Id").val();

        const form = $("#formForDownloadEdit")[0] as HTMLFormElement;

        // zober súbor (ak je zvolený)
        let fileInput = $('#fileForDownload')[0] as HTMLInputElement;
        let file = (fileInput && fileInput.files && fileInput.files.length > 0) ? fileInput.files[0] : null;

        // Ak nie je nový súbor, ulož hneď
        if (!file) {
            let request = postModalForm(url, form);

            request.done(function (res) {
                if (!res.error) {
                    if (id == 0) {
                        var row = dataTable.row.add(res.data);
                        dataTable.draw();
                        var newRow = row.node();
                        $(newRow).attr('id', 'tr_' + res.id);
                    }
                    else {
                        var row2 = dataTable.row('#tr_' + res.id);
                        row2.data(res.data).draw(false);
                    }
                    $("#editForDownloadModal").modal("toggle");
                }
                else {
                    const editorId = $("#forDownloadTinymceId").val() as string;
                    const ed = tinymce.EditorManager.get(editorId);
                    if (ed) ed.remove();

                    $("#forDownloadDetailBody").html(res.html);
                    initTinymce($("#forDownloadTinymceId").val() as string, 300);
                    initShowFileSelectModal();
                }
            });

            request.fail(function (jqXHR) {
                console.error(jqXHR)
            });

            return;
        }

        disableSaveButton();

        // Ak je nový súbor, najprv chunk upload (vyplní hidden: FileUrl/FileName/OriginalFileName)
        chunkUploadAndFillForDownloadFields(
            file,
            {
                // ak máš progress bar aj v modale, nastav selektory sem;
                // inak kľudne nechaj defaulty (alebo si ich doplň do modalu)
                progressBarSelector: "#uploadProgressBar",
                statusSelector: "#uploadStatus"
            },
            {
                fileUrlSelector: "#ForDownloads_FileUrl",
                fileNameSelector: "#FileName",
                originalFileNameSelector: "#ForDownloads_OriginalFileName",

                onDone: function () {
                    // teraz ulož form cez AJAX (už bez file v payload)
                    let request = postModalForm(url, form);

                    request.done(function (res) {
                        enableSaveButton();

                        if (!res.error) {
                            if (id == 0) {
                                var row = dataTable.row.add(res.data);
                                dataTable.draw();
                                var newRow = row.node();
                                $(newRow).attr('id', 'tr_' + res.id);
                            }
                            else {
                                var row2 = dataTable.row('#tr_' + res.id);
                                row2.data(res.data).draw(false);
                            }
                            $("#editForDownloadModal").modal("toggle");
                        }
                        else {
                            const editorId = $("#forDownloadTinymceId").val() as string;
                            const ed = tinymce.EditorManager.get(editorId);
                            if (ed) ed.remove();

                            $("#forDownloadDetailBody").html(res.html);
                            initTinymce($("#forDownloadTinymceId").val() as string, 300);
                            initShowFileSelectModal();
                        }
                    });

                    request.fail(function (xhr) {
                        enableSaveButton();

                        let msg = xhr?.responseJSON?.message || "Chyba pri nahrávaní súboru.";
                        showMessage(msg, "Chyba!"); 
                    });
                },
                onError: function (msg) {
                    enableSaveButton();
                    showMessage("Upload failed: " + msg, "Chyba!");
                }
            }
        );

    });

    function disableSaveButton() {
        const $btn = $("#btnSaveForDownload");
        $btn.prop("disabled", true);
        $btn.addClass("disabled");
        $btn.data("orig-text", $btn.html());
        $btn.html("Uploading...");
    }

    function enableSaveButton() {
        const $btn = $("#btnSaveForDownload");
        $btn.prop("disabled", false);
        $btn.removeClass("disabled");

        const origText = $btn.data("orig-text");
        if (origText) {
            $btn.html(origText);
        }
    }


}
